export const MORTGAGE = Object.freeze({
    CREATE:"/mortgage",
    LIST:"/mortgage/listing",
    UD: (id:string) => `/mortgage/${id}`
})